/**
 * Sorts reminder days array keeping non-zero values sorted and zeros at the end
 */
export function sortReminderDays(reminderDays: number[]): number[] {
  return [...reminderDays].reduce((acc, day) => {
    if (day === 0) {
      acc.push(day); // Keep zeros at end
    } else {
      // Insert sorted among non-zero values
      const insertIdx = acc.findIndex(d => d === 0 || (d > day));
      if (insertIdx === -1) {
        acc.push(day);
      } else {
        acc.splice(insertIdx, 0, day);
      }
    }
    return acc;
  }, [] as number[]);
}

/**
 * Updates a reminder day at a specific index and re-sorts if necessary
 */
export function updateReminderDayAtIndex(
  reminderDays: number[],
  idx: number,
  newValue: number | null
): number[] {
  const newDays = [...reminderDays];
  newDays[idx] = newValue === null ? 0 : newValue;

  // Only sort if this was a valid non-zero value
  if (newValue && newValue > 0) {
    // Remove from current position
    newDays.splice(idx, 1);
    // Find sorted position among non-zero values
    const insertIdx = newDays.findIndex(d => d === 0 || (d > newValue));
    if (insertIdx === -1) {
      newDays.push(newValue);
    } else {
      newDays.splice(insertIdx, 0, newValue);
    }
  }

  return newDays;
}
